"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookingsToCommonRange = void 0;
var bookingToCommonRange = function (booking) {
    var start = new Date(booking.dateStart);
    var end = new Date(start.getFullYear(), start.getMonth(), start.getDate(), start.getHours(), start.getMinutes() + parseInt(booking.snapshotPackages[0].price.duration, 10));
    var commonRange = {
        hairdresserId: booking === null || booking === void 0 ? void 0 : booking.snapshotPackages[0].hairdresserId,
        range: {
            start: booking.dateStart,
            end: end.toISOString(),
        },
    };
    return commonRange;
};
exports.BookingsToCommonRange = function (bookings) {
    var commonRanges = bookings.map(function (booking) { return bookingToCommonRange(booking); });
    return commonRanges;
};
